export default __webpack_public_path__ + "static/media/logo-disney-footer.c3f00f0e.svg";